import _ from "../../../_"
import "./index.css"
import Contact from "../../../components/holders/bubble/contact"
import Icon from "../../../components/custom/icon"
import { useState } from "react"
import API from "../../../api"

const Transaction = props => {

    const { transaction, failed, setFailed, setCaptured } = props
    var [call, setCall] = useState(transaction.call)
    var [msg, setMsg] = useState(transaction.msg)
    var [msgSending, setMsgSending] = useState()
    var [comment, setComment] = useState(transaction.remarks || "")
    var [showTick, setShowTick] = useState(false)

    var [showContact, setShowContact] = useState(false)

    const updateCallFlag = () => {
        const save = call
        setCall(call => !call)
        new API().call(call ? "/clear-call" : "/set-call", { id: transaction.id }).catch(err => {
            console.log(err)
            setCall(save)
        })
    }

    const closeIssue = () => {

        const remarks = window.prompt("Please enter remarks for closing the issue.")

        if (remarks) {

            new API().call("/close-issue", { id: transaction.id, remarks }).then(res => {
                console.log(res)
                setFailed(res.data[0])
                setCaptured(res.data[1])
            }).catch(err => {
                console.log(err)
            })
        }
    }

    const openIssue = () => {

        const conf = window.confirm("Are you sure you want to reopen issue?")

        if (conf) {
            new API().call("/open-issue", { id: transaction.id }).then(res => {
                setFailed(res.data[0])
                setCaptured(res.data[1])
            }).catch(err => {
                console.log(err)
            })
        }

    }

    const updateRemarks = () => {
        new API().call("/update-remarks", { id: transaction.id, remarks: comment }).catch(err => {
            console.log(err)
        })
    }

    const updateMsgFlag = () => {

        const conf = window.confirm(`Are you sure you want to send follow-up message${msg ? " once again" : " "}?`)

        if (conf) {
            const save = msg
            setMsgSending(true)
            new API().call("/send-followup-msg", {
                id: transaction.id,
                phone: transaction.contact.slice(-10),
                amount: transaction.amount
            }).then(() => {
                setMsg(msg => !msg)
            }).catch(err => {
                console.log(err)
                setMsg(save)
            }).finally(() => {
                setMsgSending(false)
            })
        }
    }

    return (
        <>
            {
                showContact && <Contact name={"donor"} phone={transaction.contact.slice(-10)} whatsApp={transaction.contact.slice(-10)} close={() => { setShowContact(false) }} />
            }

            <div className="trans-root flex-col">

                <div className="trans-row-1 flex-row" onClick={() => { setShowContact(true) }}>
                    <div className="flex-col">
                        <div className="trans-email">{transaction.email}</div>
                        <div className="flex-row trans-con">
                            <div className="trans-contact">{transaction.contact.slice(-10)}</div>
                            {
                                !failed && transaction.status != "captured" ?
                                    <div className="trans-non-fail">{` (${transaction.status})`}</div>
                                    : null
                            }
                        </div>
                    </div>
                    <div className="flex-col trans-right">
                        <div className={failed ? "trans-amount-fail" : "trans-amount-capt"}>{`₹ ${transaction.amount}`}</div>
                        <div className="trans-ago">{_.getTimeElapsed(transaction.time)}</div>
                    </div>
                </div>

                {failed && transaction.error && <div className="trans-error">{atob(transaction.error)}</div>}

                {failed && <>
                    <div className="flex-col trans-comment" tabIndex={0} onFocus={() => { setShowTick(true) }} onBlur={() => { setShowTick(false) }}>
                        <div style={{ marginLeft: "1vw", marginTop: "1vw", color: "#888" }}>Comments</div>
                        <div className="flex-row trans-com-box">
                            <input type="text" className="trans-com-inp" value={comment} onChange={e => setComment(e.target.value)} />
                            {showTick && <Icon name="tick" color="green" size="5" onClick={updateRemarks} />}
                        </div>
                    </div>

                    <div className="trans-row-2 flex-row">

                        {
                            transaction.closed ?
                                <div className="trans-closed">{`Issue closed: ${transaction.remarks}`}</div>
                                :
                                <div className="flex-row" style={{ marginLeft: "1vw" }}>

                                    <div className="flex-row trans-call-flag trans-button" onClick={updateCallFlag}>
                                        <div className="flex-row">
                                            <Icon name="call" size="4.5" color={call ? "#28d300" : "#888"} />
                                            <div className={`trans-call-text ${call ? "called" : ""}`}>{call ? "Called" : "Pending"}</div>
                                        </div>
                                    </div>

                                    <div className="flex-row trans-wa-flag trans-button" onClick={updateMsgFlag}>
                                        <Icon name="whatsapp" size="4.5" color={msg ? "#28d300" : "#888"} />
                                        <div className={`trans-wa-text ${msg ? "msgd" : ""}`}>{msg ? "Sent" : (msgSending ? "Sending..." : "Pending")}</div>
                                    </div>

                                </div>
                        }

                        <div className="flex-row trans-button" onClick={transaction.closed ? openIssue : closeIssue}>
                            <Icon name={transaction.closed ? "tick" : "close"} size="4.5" color={transaction.closed ? "green" : "red"} />
                            <div>{transaction.closed ? "Reopen Issue" : "Close Issue"}</div>
                        </div>

                    </div>

                </>}
            </div>
        </>

    )
}

export default Transaction